import * as types from 'store/modules/knowledge/mutation-types'
import knowledge from 'api/knowledge'
import swal from 'sweetalert'

export default {
  state: {},
  actions: {
    [types.RECEIVED_KNOWLEDGES_INFINITE_LOADING] ({ commit }, params) {
      let triggerInfinite = params.triggerInfinite
      knowledge.receivedKnowledgesInfiniteLoading(params.searchParams)
        .then((response) => {
          triggerInfinite({ data: JSON.parse(response.request.response), $state: params.$state })
        })
        .catch((error) => {
          let message = error
          if (error.response) {
            const data = error.response.data
            message = data.response
          }
          console.warn('Try recieve knowledge again', message)
          knowledge.receivedKnowledgesInfiniteLoading(params.searchParams)
            .then((response) => {
              triggerInfinite({ data: JSON.parse(response.request.response), $state: params.$state })
            })
            .catch((error) => {
              let message = error
              if (error.response) {
                const data2 = error.response.data
                message = data2.response
              }
              console.warn('warning !!! Please Refresh Page', message)
              if (message !== '' && message !== undefined) {
                swal({
                  title: '', text: message, html: true, type: 'error'
                }, function () {
                  window.onkeydown = null; window.onfocus = null; swal('')
                })
              }
            })
        })
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/knowledge/index.js